import script from "./ProfileApiKeys.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileApiKeys.vue?vue&type=script&setup=true&lang=js"

import "./ProfileApiKeys.vue?vue&type=style&index=0&id=6ec5b85c&scoped=true&lang=css"

import exportComponent from "../../../consumer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ec5b85c"]])

export default __exports__